import * as core from '../../../../../../../core'

import { query } from './edit-stakeholder-modal.query'

export const RESOURCE = {
  payload: {
    alias: 'edit.stakeholder.modal',
    description: 'Modal for editing a stakeholder',
    name: 'Edit Stakeholder Modal',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
